<div class="page">
  <div class="page__container">
    <h1 *ngIf="!rateProfileToEdit" class="page__title h2 mb-5">
      {{ 'reseller_prices_new' | translate }}
    </h1>
    <h1 *ngIf="rateProfileToEdit" class="page__title h2 mb-5">
      {{ 'reseller_profiles_edit_title' | translate }}
    </h1>

    <div class="page__form-wrap">
      <form [formGroup]="editForm">
        <!-- name field-->
        <div class="form-group row">
          <label for="rate_name" class="col-sm-4" translate>common_name</label>
          <div class="col-sm-8">
            <input type="text" id="rate_name" formControlName="name" class="form-control" name="rate_name" />
            <wsb-validation-error-msg [fc]="editForm.get('name')"></wsb-validation-error-msg>
          </div>
        </div>
        <!-- default amount field-->
        <div class="form-group row">
          <label for="rate_amount" class="col-sm-4" translate>reseller_prices_create_default</label>
          <div class="col-sm-8">
            <input type="number" id="rate_amount" formControlName="defaultAmount" class="form-control" name="rate_amount" />
            <wsb-validation-error-msg [fc]="editForm.get('defaultAmount')"></wsb-validation-error-msg>
          </div>
        </div>
        <h3 class="my-5" translate>reseller_prices_create_prices</h3>
        <!-- checkbox gpPrice -->
        <!-- <div *ngIf="isMessageType(gp)" class="form-group row d-flex flex-row" formGroupName="pricePerMessage">
                    <wsb-ui-checkbox
                        class="price-checkbox col-sm-2"
                        [(checked)]="isCheckedGpPrice"
                        [checkboxId]="'gp_price'"
                        (change)="enableSigleFormPricePerMessage(gp)">
                    </wsb-ui-checkbox>
                    <label for="gp_price" class="col-sm-2">{{ 'credit_type_gp'| translate }}</label> credit_type_gp
                <div class="col-sm-8">
                    <input
                        type="number"
                        id="gp_price"
                        formControlName="gpPrice"
                        class="form-control"
                        name="gp_price"
                        [readonly]="!isCheckedGpPrice"
                        wsbAppControlValidator
                        [fc]="editForm.get('pricePerMessage.gpPrice')">
                        <wsb-validation-error-msg [fc]="editForm.get('pricePerMessage.gpPrice')"></wsb-validation-error-msg>
                    </div>
                    <span translate>common_currency</span>
                    </div> -->
        <!-- checkbox gsPrice -->
        <!-- <div *ngIf="isMessageType(gs)" class="form-group row" formGroupName="pricePerMessage">
                <wsb-ui-checkbox
                    class="price-checkbox col-sm-2"
                    [(checked)]="isCheckedGsPrice"
                    [checkboxId]="'gs_price'"
                    (change)="enableSigleFormPricePerMessage(gs)">
                </wsb-ui-checkbox>
                <label for="gs_price" class="col-sm-2">{{ 'credit_type_gs'| translate }}</label> credit_type_gs
                <div class="col-sm-8">
                <input
                    type="number"
                    id="gs_price"
                    formControlName="gsPrice"
                    class="form-control"
                    name="gs_price"
                    [readonly]="!isCheckedGsPrice"
                    wsbAppControlValidator
                    [fc]="editForm.get('pricePerMessage.gsPrice')">
                    <wsb-validation-error-msg [fc]="editForm.get('pricePerMessage.gsPrice')"></wsb-validation-error-msg>
                </div>
                <span translate>common_currency</span>
            </div> -->
        <!-- checkbox tiPrice -->
        <!-- <div *ngIf="isMessageType(ti)" class="form-group row" formGroupName="pricePerMessage">
                <wsb-ui-checkbox
                    class="price-checkbox  col-sm-2"
                    [(checked)]="isCheckedTiPrice"
                    [checkboxId]="'ti_price'"
                    (change)="enableSigleFormPricePerMessage(ti)">
                </wsb-ui-checkbox>
                <label for="ti_price" class="col-sm-2">{{ 'credit_type_ti'| translate }}</label> credit_type_ti
                <div class="col-sm-8">
                <input
                    type="number"
                    id="ti_price"
                    formControlName="tiPrice"
                    class="form-control"
                    name="ti_price"
                    [readonly]="!isCheckedTiPrice"
                    wsbAppControlValidator
                    [fc]="editForm.get('pricePerMessage.tiPrice')">
                    <wsb-validation-error-msg [fc]="editForm.get('pricePerMessage.tiPrice')"></wsb-validation-error-msg>
                </div>
                <span translate>common_currency</span>
            </div> -->
        <!-- checkbox siPrice -->
        <!-- <div *ngIf="isMessageType(si)" class="form-group row" formGroupName="pricePerMessage">
                <wsb-ui-checkbox
                    class="price-checkbox col-sm-2"
                    [(checked)]="isCheckedSiPrice"
                    [checkboxId]="'si_price'"
                    (change)="enableSigleFormPricePerMessage(si)">
                </wsb-ui-checkbox>
                <label for="si_price" class="col-sm-2">{{ 'credit_type_si'| translate }}</label> credit_type_si
                <div class="col-sm-8">
                <input
                    type="number"
                    id="si_price"
                    formControlName="siPrice"
                    class="form-control"
                    name="si_price"
                    [readonly]="!isCheckedSiPrice"
                    wsbAppControlValidator
                    [fc]="editForm.get('pricePerMessage.siPrice')">
                    <wsb-validation-error-msg [fc]="editForm.get('pricePerMessage.siPrice')"></wsb-validation-error-msg>
                </div>
                <span translate>common_currency</span>
            </div> -->
        <!-- checkbox adPrice -->
        <!-- <div *ngIf="isMessageType(adv)" class="form-group row" formGroupName="pricePerMessage">
                <wsb-ui-checkbox
                    class="price-checkbox col-sm-2"
                    [(checked)]="isCheckedAdPrice"
                    [checkboxId]="'ad_price'"
                    (change)="enableSigleFormPricePerMessage(adv)">
                </wsb-ui-checkbox>
                <label for="ad_price" class="col-sm-2">{{ 'credit_type_ad'| translate }}</label> credit_type_ad
                <div class="col-sm-8">
                <input
                    type="number"
                    id="ad_price"
                    formControlName="adPrice"
                    class="form-control"
                    name="ad_price"
                    [readonly]="!isCheckedAdPrice"
                    wsbAppControlValidator
                    [fc]="editForm.get('pricePerMessage.adPrice')">
                    <wsb-validation-error-msg [fc]="editForm.get('pricePerMessage.adPrice')"></wsb-validation-error-msg>
                </div>
                <span translate>common_currency</span>
            </div> -->
        <!-- checkbox eePrice -->
        <!-- <div class="form-group row" formGroupName="pricePerMessage">
                <wsb-ui-checkbox
                    class="price-checkbox col-sm-2"
                    [(checked)]="isCheckedEePrice"
                    [checkboxId]="'ee_price'"
                    (change)="enableSigleFormPricePerMessage(ee)">
                </wsb-ui-checkbox>
            <label for="ee_price" class="col-sm-2">{{ 'credit_type_ee'| translate }}</label> credit_type_ee
            <div class="col-sm-8">
            <input
                    type="number"
                    id="ee_price"
                    formControlName="eePrice"
                    class="form-control"
                    name="ee_price"
                    [readonly]="!isCheckedEePrice"
                    wsbAppControlValidator
                    [fc]="editForm.get('pricePerMessage.eePrice')"/>
                    <wsb-validation-error-msg [fc]="editForm.get('pricePerMessage.eePrice')"></wsb-validation-error-msg>
                </div>
                <span translate>common_currency</span>
            </div> -->

        <div formArrayName="pricePerMessage">
          <div *ngFor="let item of pricePerMessage.controls; let i = index">
            <div *ngIf="isMessageType(item.controls.type.value)" class="form-group row align-items-center" [formGroupName]="i">
              <wsb-ui-checkbox
                class="price-checkbox col-sm-2"
                [(checked)]="item.controls.cost.value"
                [checkboxId]="'check_price_' + i"
                (change)="setCheckedPrice(item)"
              >
              </wsb-ui-checkbox>
              <!-- <label for="check_price_{{i}}" class="col-sm-2" *ngIf="item.controls.idDestinationNation.value">{{ findLabelNation(item.controls.idDestinationNation.value)}}</label>  
                    <label for="check_price_{{i}}" class="col-sm-2" *ngIf="!item.controls.idDestinationNation.value">{{ 'credit_type_'+item.controls.type.value.toLowerCase() | translate}}</label>   -->
              <label for="check_price_{{ i }}" class="col-sm-2">{{
                findLabelTypeNation(item.controls.type.value.toLowerCase(), item.controls.idDestinationNation.value)
              }}</label>
              <div class="col-sm-7">
                <input
                  step="0.001"
                  type="number"
                  id="price_{{ i }}"
                  formControlName="cost"
                  class="form-control"
                  [readonly]="isReadOnly(item)"
                  name="price_{{ i }}"
                  wsbAppControlValidator
                  [fc]="item.controls.cost"
                />
                <wsb-validation-error-msg [fc]="item.controls.cost"></wsb-validation-error-msg>
              </div>
              <div class="col-sm-1">
                <span translate>common_currency</span>
              </div>
              <div
                class="col-sm-1 mb-1"
                *ngIf="item.controls.idDestinationNation.value && item.controls.idDestinationNation.value !== user.nation"
              >
                <wsb-atlas-button [variant]="'danger'" [icon]="faTrash" (click)="removePricePerNation(i)">{{
                  'common_delete' | translate
                }}</wsb-atlas-button>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-2 offset-sm-2 ">{{ 'search_nations' | translate }}</label>
            <div class="col-sm-7">
              <ng-select
                (change)="selectNation($event)"
                [items]="nations"
                bindLabel="label"
                [searchable]="true"
                bindValue="id"
                [clearable]="false"
                class="form-control"
              >
              </ng-select>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="page__actions actions-bar" #actionsBar style="z-index: 1">
      <span class="actions-bar__bg"></span>
      <div class="actions-bar__container" toastContainer></div>
      <div class="actions-bar__container  actions-bar__container--actions">
        <div class="d-flex">
          <button
            #submitBtn
            class="btn btn-primary btn-sm"
            [disabled]="editForm.pristine || editForm.invalid"
            (click)="submitForm()"
            translate
          >
            common_save
          </button>
          <button #submitBtn (click)="goBack()" class="btn  btn-secondary ms-3 btn-sm" translate>common_back</button>
          <button *ngIf="editForm.dirty" type="button" class="btn btn-link btn-sm ms-4" (click)="resetForm()" translate>
            common_cancel
          </button>
        </div>
        <div *ngIf="!editForm.pristine" class="mt-2">
          <small translate>common_unsaved_changes</small>
        </div>
      </div>
    </div>
  </div>
</div>
